import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './styles.css';

const MobileSignupModal = ({ isOpen, onClose, onContinue }) => {
  const { loginWithRedirect } = useAuth0();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Wait for animation to complete
  };

  const handleContinue = () => {
    setIsVisible(false);
    setTimeout(() => {
      onContinue();
    }, 300);
  };


  if (!isOpen) return null;

  return (
    <div className="mobile-signup-modal-overlay" onClick={handleClose}>
      <div 
        className={`mobile-signup-modal ${isVisible ? 'visible' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mobile-signup-modal-header">
          <div className="mobile-signup-modal-icon">💻</div>
          <button 
            className="mobile-signup-modal-close"
            onClick={handleClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>
        
        <div className="mobile-signup-modal-content">
          <h3 className="mobile-signup-modal-title">
            You can now sign up on mobile! 🎉
          </h3>
          
          <p className="mobile-signup-modal-message">
            Start securing your family's digital legacy today. 
            Create your account and begin building your family vault.
          </p>
          
          <p className="mobile-signup-modal-desktop-note">
            <em>For better experience, use our app on desktop</em>
          </p>
          
          <div className="mobile-signup-modal-features">
            <div className="feature-item">
              <span className="feature-icon">🖥️</span>
              <span>Full feature access</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎯</span>
              <span>Better navigation</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">⚡</span>
              <span>Faster performance</span>
            </div>
          </div>
          
          <div className="mobile-signup-modal-actions">
            <button 
              className="mobile-signup-modal-button primary-button"
              onClick={handleContinue}
            >
              <span className="button-icon">🚀</span>
              Sign Up Now
            </button>
          </div>
          
          <p className="mobile-signup-modal-note">
            Mobile optimization is part of our roadmap and coming soon!
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileSignupModal;
